import script from "./TabLights.vue?vue&type=script&setup=true&lang=js"
export * from "./TabLights.vue?vue&type=script&setup=true&lang=js"

import "./TabLights.vue?vue&type=style&index=0&id=a3fe0d88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3fe0d88"]])

export default __exports__